import { hasModelHome, hasReadyToBuild, ProductType, ResultType, selectResultType } from "features/searchResultsFacets";
import { store$ } from "@redux/store";
import { distinctUntilChanged, map } from "rxjs";
import { buildNewUrl } from "features/routing";
import fastdom from "fastdom";
import ResultTab from "./resultTab";
import UrlSubdirectoryTypes from "../../enums/urlSubdirectoryTypes";
import { urlComponentsWithHomeStatusSelector } from "../../redux/selectors";


export default class HomesTab extends ResultTab {
  constructor() {
    super();
    this.isActive = false;
    this.url = '';
    this.qaAttribute = 'filters-result-type-homes';
    this.subdirectory = UrlSubdirectoryTypes.Homes.toString();
    this.content = 'Homes';
    this.resultType = ResultType.Homes.toString();
    this.productType = ProductType.Homes.toString();
    this.googleAnalyticsTrackingClass = 'tagmanager_hometab';
    this.tabCLass = 'nhs-c-tab';

    const resultTypeChange$ = store$.pipe(
      map(selectResultType),
      map((resultType) => this.resultType === resultType),
      distinctUntilChanged(),
    );
    resultTypeChange$.subscribe(this.setIsActive.bind(this));

    const urlSegmentsChange$ = store$.pipe(
      map(urlComponentsWithHomeStatusSelector),
      distinctUntilChanged(),
    );

    urlSegmentsChange$.subscribe(this.updateUrlSegments.bind(this));
  }

  updateUrlSegments({ urlComponents, homeStatus }) {
    const { urlSubdirectory, urlCoordinatesQueryString, urlLocation, urlQueryString, urlBuilderName } = urlComponents;

    const newSubdirectory = this.updateSubdirectory(urlSubdirectory, homeStatus);
    const urlConfiguration = {
      urlSubdirectory: newSubdirectory,
      urlCoordinatesQueryString,
      urlLocation,
      urlQueryString,
      urlBuilderName
    }

    this.url = buildNewUrl(urlConfiguration);
    this.updateUrl(this.url);
    fastdom.mutate(() => {
      const tabElement = this.getNode();
      if (tabElement) {
        tabElement.href = this.url;
      }
    });
  }

  updateSubdirectory(urlSubdirectory, homeStatus) {

    switch (true) {

      case urlSubdirectory === UrlSubdirectoryTypes.CondosAndTownHomes.toString():
      case urlSubdirectory === UrlSubdirectoryTypes.CondoDevelopment.toString():
        return UrlSubdirectoryTypes.CondosAndTownHomes.toString();

      case urlSubdirectory === UrlSubdirectoryTypes.SingleFamilyHomes.toString():
      case urlSubdirectory === UrlSubdirectoryTypes.SingleFamilyCommunities.toString():
        return UrlSubdirectoryTypes.SingleFamilyHomes.toString();

      case hasReadyToBuild(homeStatus):
        return UrlSubdirectoryTypes.FloorPlans.toString();

      case hasModelHome(homeStatus):
        return UrlSubdirectoryTypes.ModelHomes.toString();
      default:
        return this.subdirectory;
    }
  }

  getHTML() {
    const classesList = [this.googleAnalyticsTrackingClass, this.tabCLass];
    if (this.isActive) {
      classesList.push('nhs-c-tab--active');
    }

    return `<a href='${this.url}' class='${classesList.join(' ')}' data-result-type='${this.resultType}'
            data-product-type='${this.productType}' data-qa=${this.qaAttribute}>${this.content}</a>`;
  }
}
